export default function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
}



//////////////////
// WEBPACK FOOTER
// ./packages/element/node_modules/d3-shape/src/pointRadial.js
// module id = 88
// module chunks = 0